import { Link } from "react-router-dom";
import { Anchor, Divider, Stack, Text, Title } from "@mantine/core";
import { SocialButtons } from "../../entities/components/SocialButtons";
import { SignInForm } from "../../features/sign-in/SignInForm";
import { useTranslation } from "react-i18next";
import { FC, useState } from "react";

interface Props {
  setMaxStep: (num: number) => void;
}

export const SignInWiget: FC<Props> = ({ setMaxStep }) => {
  const { t } = useTranslation();

  const [isSocialLoading, setIsSocialLoading] = useState(false);

  return (
    <Stack align="stretch" justify="center" gap="24px">
      <Title size={36}>{t("sign_in_title")}</Title>
      <Text c="dimmed" size="md">
        {t("log_in_with_social_media")}
      </Text>
      <SocialButtons
        setIsSocialLoading={setIsSocialLoading}
        setMaxStep={setMaxStep}
      />
      <Divider
        label={
          <Text c="dimmed" size="md">
            {t("or")}
          </Text>
        }
        labelPosition="center"
      />
      <Text c="dimmed" size="md">
        {t("log_in_with_email")}
      </Text>
      <SignInForm isSocialLoading={isSocialLoading} />
      <Text c="dimmed" size="md">
        {t("dont_have_account")}{" "}
        <Anchor
          c="dimmed"
          to="/auth/sign-up"
          underline="always"
          component={Link}
        >
          {t("sign_up_link")}
        </Anchor>
      </Text>
      <Anchor
        c="dimmed"
        to="/login/forgot-password"
        underline="always"
        component={Link}
      >
        {t("forgot_password_link")}
      </Anchor>
    </Stack>
  );
};
